import React from 'react'
import { Icons } from '@blueprintjs/icons'
import '../vendor/sentry'
import App from '../App'
import config from '../config'
import canny from '../vendor/canny'
import { bootstrapRoot } from '../bootstrapRoot'

// bootstrap
import { initializeLaunchDarkly } from '../featureFlags'

// Blueprint v5 loads icon SVGs asynchronously, split by icon+size, by default - the first render
// of any given icon briefly shows an icon-font fallback before swapping to SVG. Loading everything
// up front avoids that flash, matching how icons behaved (statically bundled) before v5.
Icons.setLoaderOptions({ loader: 'all' })
Icons.loadAll()

initializeLaunchDarkly().finally(() => {
  bootstrapRoot(<App />)
})

if (config.user.role === 'admin' && import.meta.env.MODE === 'production') {
  canny()
}
